import Breadcrumb, { type Crumb } from "@/components/feature/Breadcrumb";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  image: string;
  crumbs: Crumb[];
}

export default function PageHero({ title, subtitle, image, crumbs }: PageHeroProps) {
  return (
    <section className="relative w-full h-[280px] md:h-[360px] flex items-center overflow-hidden">
      <img
        src={image}
        alt={title}
        title={title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85"></div>
      <div className="container-site relative z-10 w-full pt-16">
        <div className="[&_a]:text-background-200 [&_span]:text-background-100 [&_i]:text-background-300">
          <Breadcrumb items={crumbs} />
        </div>
        <h1 className="font-heading font-extrabold text-3xl md:text-5xl text-background-50 mt-4">
          {title}
        </h1>
        {subtitle && (
          <p className="text-background-200 mt-3 max-w-2xl text-sm md:text-base leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}